import { render, staticRenderFns } from "./AccessWalletLedger.vue?vue&type=template&id=812392a4&scoped=true&"
import script from "./AccessWalletLedger.vue?vue&type=script&lang=js&"
export * from "./AccessWalletLedger.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletLedger.vue?vue&type=style&index=0&id=812392a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812392a4",
  null
  
)

export default component.exports